export class GroundCommon {
  needsClear(oldScenes, newScenes) {
    if (oldScenes.length !== newScenes.length)
    return true;
    for (let i = 0; i < oldScenes.length; i++) {
      // Avoid pitfall that [] != [] is true although we consider them equal here.
      // Without this the inequality check below would always request a clear for an empty scenes array.
      if (oldScenes[i].length == 0 && newScenes[i].length == 0)
      continue;

      if (oldScenes[i] != newScenes[i]) {
        return true;
      }
    }
    return undefined;
  }
}